import 'babel-polyfill'
import Promise from 'promise-polyfill'
import 'form-service/frontend/lib/assets/sass/main.scss'
import config from 'form-service'

if (!window.Promise) {
  window.Promise = Promise
}

if (module.hot) {
  module.hot.accept()
}


if (!process.env.NODE_ENV_SETTINGS) {
  throw new Error('Enviroment variable NODE_ENV_SETTINGS not specified')
}

let formServiceUrl
let OAUTHUrl
let OAUTHRedirectUrl

if (process.env.NODE_ENV_SETTINGS === 'develop') {
  formServiceUrl = 'https://mazda-forms.dev.perx.ru/forms/api/v1'
  OAUTHUrl = 'https://mazda-forms.dev.perx.ru/auth'
  OAUTHRedirectUrl = 'https://mazda-forms.dev.perx.ru/'
} else if (process.env.NODE_ENV_SETTINGS === 'production') {
  formServiceUrl = 'https://forms.mazda.ru/forms/api/v1'
  OAUTHUrl = 'https://forms.mazda.ru/auth'
  OAUTHRedirectUrl = 'https://forms.mazda.ru/'
}

if (formServiceUrl && OAUTHUrl && OAUTHRedirectUrl) {
  config({
    appId: 'form-service-admin',
    formServiceUrl,
    statuses: [
      'Выполнен',
      'Отложен',
    ],
    auth: {
      OAUTHUrl,
      OAUTHRedirectUrl,
      OAUTHClientId: 'mazdaFormsFront',
      OAUTHSecret: 'ZTNiMGM0NDI5OGZjMWMxNDlhZmJmNGM4',
      isImplicit: true,
      realms: ['mazda-forms'],
      loginTemplate: 'login',
      isJWT: true
    }
  })
}




// WEBPACK FOOTER //
// ./index.js